import { bunja } from 'bunja';

import { i18nBunja } from '@flipster/i18n';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment, { WalletEvent } from '@flipster/utils/segment';

import { depositModalBunja } from './state';

export const walletModalEventBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { currencyDepositNetworkAtom, networkItemsAtom, selectedCurrencyAtom, selectedNetworkAtom } =
    bunja.use(depositModalBunja);
  const { getT } = bunja.use(i18nBunja);
  const t = getT();

  function onNetworkSelectBoxOpen() {
    const { isCongested, estTimeMin } = store.get(currencyDepositNetworkAtom) ?? {};
    const networkStatusText = (() => {
      if (!estTimeMin) return t('Deposit.r250401.May_be_delayed');
      if (isCongested) return t('Deposit.r250401.Congested');
    })();
    segment.track(WalletEvent.DepositNetworkOpenClick, {
      currency: store.get(selectedCurrencyAtom),
      network: store.get(selectedNetworkAtom),
      networkStatus: networkStatusText,
    });
  }
  function onNetworkSelect(value?: string) {
    const networkItems = store.get(networkItemsAtom);
    segment.track(WalletEvent.DepositNetworkClick, {
      currency: store.get(selectedCurrencyAtom),
      network: value,
      list_order: networkItems.map((item) => item.value).indexOf(value!),
    });
  }
  function onAddressCopied() {
    segment.track(WalletEvent.AddressCopied, {
      currency: store.get(selectedCurrencyAtom),
      network: store.get(selectedNetworkAtom),
    });
  }
  function onDestinationTagCopied() {
    segment.track(WalletEvent.DestinationTagCopied, {
      type: 'tag',
      currency: store.get(selectedCurrencyAtom),
      network: store.get(selectedNetworkAtom),
    });
  }
  function onMemoCopied() {
    segment.track(WalletEvent.DestinationTagCopied, {
      type: 'memo',
      currency: store.get(selectedCurrencyAtom),
      network: store.get(selectedNetworkAtom),
    });
  }
  return {
    onNetworkSelectBoxOpen,
    onNetworkSelect,
    onAddressCopied,
    onDestinationTagCopied,
    onMemoCopied,
  };
});
walletModalEventBunja.debugLabel = 'walletModalEventBunja';
